export const PRODUCT_BUTTONS = {
  TRAV: [
    { label: 'Country Mapping', link: 'country-mapping' },
    { label: 'Medical Rules', link: 'medical-rules' },
    { label: 'Assistance / Claims handler', link: 'handlers' },
    { label: 'SMS confirmation', link: 'sms-confirmation' },
    { label: 'Documents', link: 'documents' },
    { label: 'Channels', link: 'channels' },
    { label: 'Sanctions', link: 'sanctions' },
    { label: 'Notes', link: 'notes' },
    { label: 'Audit', link: 'audit' },
  ],
  CC: [
    { label: 'Channels', link: 'channels' },
    { label: 'Sanctions', link: 'sanctions' },
    { label: 'Notes', link: 'notes' },
    { label: 'Audit', link: 'audit' },
  ],
  PA: [
    { label: 'Channels', link: 'channels' },
    { label: 'Sanctions', link: 'sanctions' },
    { label: 'Notes', link: 'notes' },
    { label: 'Audit', link: 'audit' },
  ],
  SC: [
    { label: 'Channels', link: 'channels' },
    { label: 'Sanctions', link: 'sanctions' },
    { label: 'Notes', link: 'notes' },
    { label: 'Audit', link: 'audit' },
  ],
  HCP: [
    { label: 'Channels', link: 'channels' },
    { label: 'Sanctions', link: 'sanctions' },
    { label: 'Notes', link: 'notes' },
    { label: 'Audit', link: 'audit' },
  ],
  SL: [
    { label: 'Channels', link: 'channels' },
    { label: 'Sanctions', link: 'sanctions' },
    { label: 'Notes', link: 'notes' },
    { label: 'Audit', link: 'audit' },
  ],
};
